import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/motivos-de-suspensiones-de-pagos';

/**
 * GET Motivos de Suspensión de Pagos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getMotivosDeSuspensionDePagos = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Motivo de Suspensión de Pago
 * @params {number} id
 * @returns {Promise<object|null>}
 */
export const getMotivoDeSuspensionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
/**
 * POST Motivo de Suspensión de Pago
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotivoDeSuspensionDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motivo de Suspensión de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotivoDeSuspensionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motivo de Suspensión de Pago
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteMotivoDeSuspensionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
